<template>
  <v-dialog
    v-model="show"
    content-class="elevation-0"
    width="600"
  >
    <v-card class="free-email-providers rounded-0">
      <div class="free-email-providers__header">
        <div class="free-email-providers__title">Free email providers</div>
        <v-icon class="pointer" @click="show = false">mdi-close</v-icon>
      </div>

      <div class="free-email-providers__subtitle">
        {{ filteredProviders.length }} of {{ allFreeEmailProviders.length }} providers
      </div>

      <common-input
        v-model="search"
        placeholder="Search by domain"
        height="40"
        clearable
        class="free-email-providers__search"
      />

      <div class="free-email-providers__list">
        <div v-if="!filteredProviders.length" class="free-email-providers__empty">
          No providers match "{{ search }}".
        </div>
        <div
          v-for="provider in filteredProviders"
          :key="provider"
          class="free-email-providers__item"
        >
          {{ provider }}
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import panelVModel from '@/mixins/panelVModel'
import { ALL_FREE_EMAIL_PROVIDERS } from './allFreeEmailProviders'

export default {
  name: 'TheFreeEmailProvidersModal',
  mixins: [panelVModel],
  data: () => ({
    allFreeEmailProviders: ALL_FREE_EMAIL_PROVIDERS,
    search: '',
  }),
  computed: {
    filteredProviders () {
      const query = this.search.trim().toLowerCase()
      if (!query) return this.allFreeEmailProviders

      return this.allFreeEmailProviders.filter((provider) => provider.includes(query))
    }
  },
  watch: {
    show (val) {
      if (!val) this.search = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.free-email-providers {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__title {
    font-family: 'Lato-Bold', sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: #000;
  }

  &__subtitle {
    font-family: 'Lato-Italic', sans-serif;
    font-style: italic;
    font-size: 13px;
    color: #95979D;
  }

  &__list {
    max-height: 400px;
    overflow-y: auto;
    border: 1px solid #DEDEDE;
  }

  &__item {
    padding: 8px 16px;
    font-family: 'Lato-Regular', sans-serif;
    font-size: 14px;
    color: #000;
    border-bottom: 1px solid #F4F4F4;

    &:last-child {
      border-bottom: none;
    }
  }

  &__empty {
    padding: 16px;
    font-family: 'Lato-Italic', sans-serif;
    font-style: italic;
    font-size: 14px;
    color: #95979D;
  }
}
</style>
